import { List, TextField, EditButton, SimpleList, Datagrid, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT, PRACTICES } from "utils/constants";
import { EducationsExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListPractices = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={EducationsExporter(PRACTICES)} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreatePractices)} />}
      title="Списък с практики"
      sx={settings.style.expandStyle}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
          )}
          tertiaryText={record => (
            <>{checkPermission(userPermissions, permissions.canUpdatePractices) && <EditButton label="" />}</>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdatePractices) && <EditButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListPractices;
